module.exports = __webpack_public_path__ + "static/img/image037.736325a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image037.png
// module id = QFa+
// module chunks = 1